import EditLanguagesModal from './EditLanguagesModal';

export default EditLanguagesModal;
